export default "__VITE_ASSET__B$EMp4iQ__"